import { useMemo } from "react";
/**
 * useTMDBSuggestions
 *
 * @description Combines TMDB find-by-IMDb results and search results into a
 * unified suggestions array. Find-by-IMDb results are placed first (highest
 * priority), followed by user-typed search results.
 *
 * @param {UseTMDBSuggestionsProps} props - The properties for the hook.
 * @param {TMDBSearchDropdownItem[]} props.findByData - Results from TMDB find-by-IMDb lookup.
 * @param {TMDBSearchDropdownItem[]} props.searchData - Results from TMDB user search.
 * @returns {TMDBSearchDropdownItem[]} - Combined and normalized TMDB suggestions.
 *
 */
const useTMDBSuggestions = ({ findByData, searchData }) => useMemo(() => {
    // Pre-filled result from IMDbID lookup (highest priority)
    const findByResults = findByData || [];
    // User-typed search results
    const searchResults = searchData || [];
    // Combine: findBy result first, then search results
    return [...findByResults, ...searchResults];
}, [findByData, searchData]);
export default useTMDBSuggestions;
